/*=========================================================================================
  File Name: getters.js
  namespace: exercises
  Description: Vuex Store - Exercise getters
==========================================================================================*/
import {
  buildExerciseState
} from './state'

const getters = {
  getCurrentExercise: state => {
    return state.currentExercise
  },
  getNewExercise: () => {
    return buildExerciseState()
  },
  getExerciseList: state => {
    return {
      results: state.results,
      count: state.count
    }
  },
  getExerciseEntries: state => {
    return state.exerciseList
  },
  getCurrentExerciseFiles: state => {
    return state.currentExerciseFiles
  },
  getCurrentTests: state => {
    return state.currentTests
  },
  getCurrentSolutions: state => {
    return state.currentSolutions
  }
}

export default getters
